import { createSlice, Slice } from "@reduxjs/toolkit";

const STEPS = [
  {
    step: "1. Shaping",
    checked: false,
    id: "shaping",
    slug: "shaping_step",
  },
  {
    step: "2. Questionnaire",
    checked: false,
    id: "questionnaire",
    slug: "questionnaire_step",
  },
];

interface GeneralState {
  showQuestion: boolean;
  questionAnswer: any;
  registrationFinished: any;
  tab: number;
  steps: any;
  currentStep: number;
  question: any;
  outcomeQuestion: any;
  clientId: any;
  category: string;
  skills: any;
  skillsLoading: boolean;
  wave2Question: any;
  isApiInProgrees: boolean;
  experienceData: any;
  isDefaultLock: boolean;
  apiStatus: string;
  activeFlow: any;
  isHidePerfecting: boolean;
  host: string;
}

const initialState = {
  showQuestion: false,
  questionAnswer: {
    contactedByAgency: null,
    registrationFinished: null,
  },
  tab: 0,
  steps: STEPS,
  currentStep: 0,
  question: null,
  outcomeQuestion: null,
  clientId: null,
  category: "",
  skills: [],
  skillsLoading: true,
  wave2Question: null,
  isApiInProgrees: false,
  isDefaultLock: false,
  experienceData: null,
  apiStatus: "idel",
  activeFlow: "",
  isHidePerfecting: false,
  host: "successagency",
} as GeneralState;

const updateQuestion = (state: GeneralState) => {
  return {
    ...state,
    showQuestion: true,
  };
};
const updateAnswer = (state: GeneralState, key: string, value: any) => {
  return {
    ...state,
    questionAnswer: {
      ...state.questionAnswer,
      [key]: value,
    },
    tab: state.tab + 1,
  };
};

const updateStep = (state: GeneralState, payload: any) => {
  const updatedSteps = state.steps.map((step: any) =>
    step.id === payload.id ? { ...step, checked: payload.checked } : step
  );
  return { ...state, steps: updatedSteps };
};
export const general: Slice<GeneralState> = createSlice({
  name: "general",
  initialState,
  reducers: {
    updateHost: (state, action) => {
      return {
        ...state,
        host: action.payload,
      };
    },
    showUsersQuestion: (state) => updateQuestion(state),
    updateQuestionAnswer: (state, action) =>
      updateAnswer(state, action.payload.key, action.payload.value),
    updateProgressStep: (state, action) => updateStep(state, action.payload),
    updateCurrentStep: (state, action) => {
      return {
        ...state,
        currentStep: action.payload,
      };
    },
    setQualificationQuestion: (state, action) => {
      return {
        ...state,
        question: action.payload,
      };
    },
    setActiveTab: (state, action) => {
      return {
        ...state,
        tab: action.payload,
      };
    },
    setShowQuestions: (state, action) => {
      return {
        ...state,
        showQuestion: action.payload,
      };
    },
    setOutComeQuestion: (state, action) => {
      return {
        ...state,
        outcomeQuestion: action.payload,
      };
    },
    setClientId: (state, action) => {
      return {
        ...state,
        clientId: action.payload,
      };
    },
    setElaborationCategory: (state, action) => {
      return {
        ...state,
        category: action.payload,
      };
    },
    setCandidateSkills: (state, action) => {
      return {
        ...state,
        skills: action.payload,
      };
    },
    setSkillsLoading: (state, action) => {
      return {
        ...state,
        skillsLoading: action.payload,
      };
    },
    setWave2Question: (state, action) => {
      return {
        ...state,
        wave2Question: action.payload,
      };
    },
    setApiState: (state, action) => {
      return {
        ...state,
        isApiInProgrees: action.payload,
      };
    },
    setPerfectingHide: (state, action) => {
      return {
        ...state,
        isHidePerfecting: action.payload,
      };
    },
    setDefaultLockState: (state, action) => {
      return {
        ...state,
        isDefaultLock: action.payload,
      };
    },
    setExperienceData: (state, action) => {
      return {
        ...state,
        experienceData: action.payload,
      };
    },
    handleApiStatus: (state, action) => {
      return {
        ...state,
        apiStatus: action.payload,
      };
    },
    setActiveFlow: (state, action) => {
      return {
        ...state,
        activeFlow: action.payload,
      };
    },
  },
});

export const {
  showUsersQuestion,
  setActiveTab,
  setShowQuestions,
  updateQuestionAnswer,
  updateProgressStep,
  updateCurrentStep,
  setQualificationQuestion,
  setOutComeQuestion,
  setClientId,
  setElaborationCategory,
  setCandidateSkills,
  setSkillsLoading,
  setWave2Question,
  setApiState,
  setPerfectingHide,
  handleApiStatus,
  setExperienceData,
  setActiveFlow,
  setDefaultLockState,
  updateHost,
} = general.actions;
export default general.reducer;
